import { render, staticRenderFns } from "./compileRightsGroups.vue?vue&type=template&id=2f41271a&scoped=true&"
import script from "./compileRightsGroups.vue?vue&type=script&lang=js&"
export * from "./compileRightsGroups.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/common/nav.less?vue&type=style&index=0&id=2f41271a&scoped=true&lang=less&"
import style1 from "../../../assets/css/common/table.less?vue&type=style&index=1&id=2f41271a&scoped=true&lang=less&"
import style2 from "./compileRightsGroups.vue?vue&type=style&index=2&id=2f41271a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f41271a",
  null
  
)

export default component.exports